module.exports = __webpack_public_path__ + "img/roundClose.cc4654ab.svg";